import actions from './actions';

const { STRIPE_INVITATION_BEGIN, STRIPE_INVITATION_SUCCESS, STRIPE_INVITATION_ERR } = actions;

const initState = {
  list: null,
  loading: false,
  error: null,
};

/**
 *
 * @todo impure state mutation/explaination
 */
const StripeReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case STRIPE_INVITATION_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case STRIPE_INVITATION_SUCCESS:
      return {
        ...state,
        list: data,
        loading: false,
      };
    case STRIPE_INVITATION_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default StripeReducer;
